/* eslint react/no-danger:0 */
import { connect } from 'react-redux';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Alert } from 'kepler';

// Lib.
import Page from '../../lib/page';

import { ALERT } from '../constants/PropTypesShapes';

const vxTypeMapping = {
  critical: 'error',
  info: 'help',
  warning: 'warning',
};

export class Alerts extends Component {
  static createMarkup(alertMessage) {
    return { __html: alertMessage };
  }

  // Return the Dismissed Alert Cookie name by Page Wise.
  static getAlertCookie() {
    return Page.getCookie('dismissed-alerts');
  }

  // Return True, If the Cookie is already dismissed.
  static isDismissedAlert(type) {
    const dismissedAlertsCookie = Alerts.getAlertCookie();

    if (dismissedAlertsCookie && dismissedAlertsCookie[type]) {
      return true;
    }

    return false;
  }

  // Set the Current Alert as dismissed and store it in Cookie.
  static setAsDismissed(type) {
    const dismissedAlertsCookie = Alerts.getAlertCookie();
    const dismissedAlerts = dismissedAlertsCookie || {
      info: false,
      warning: false,
    };

    dismissedAlerts[type] = true;

    Page.setCookie('dismissed-alerts', JSON.stringify(dismissedAlerts), {
      path: '/',
    });
  }

  // Remove the Alert DOM after its got dismissed and stored in Cookie.
  static removeDimissedAlert(node) {
    const alertNode = ReactDOM.findDOMNode(node); // eslint-disable-line
    ReactDOM.unmountComponentAtNode(alertNode);
    if (alertNode.remove) {
      alertNode.remove();
    } else {
      alertNode.outerHTML = '';
    }
  }

  // Return all `alerts` to Home Page and add only `critical` alert to other sub page.
  getAlerts() {
    const alerts = this.props.alerts;
    // Show only `critical` alerts if its not Home page.
    if (!Page.isHomePage()) {
      return alerts.filter(alert => (alert.messageType === 'critical'));
    }

    return alerts;
  }


  renderAlerts() {
    return this.getAlerts()
      .map((alert) => {
        if (!alert) {
          return null;
        }

        const { messageType, message, docid } = alert;

        if (Alerts.isDismissedAlert(alert.messageType)) {
          return null;
        }

        const type = vxTypeMapping[messageType] || vxTypeMapping.info;

        // Add the Dismissable `Alert`.
        // Store the `Dismissed Alert id` in Cookie onDismiss.
        return (
          <Alert
            key={docid} dismissable={messageType !== 'critical'} type={type} onDismiss={(alertNode) => {
              Alerts.removeDimissedAlert(alertNode);
              Alerts.setAsDismissed(messageType);
            }}
          >
            <div dangerouslySetInnerHTML={Alerts.createMarkup(message)} role="alert" />
          </Alert>
        );
      });
  }

  render() {
    return (
      <div className="alert-container">
        {this.renderAlerts()}
      </div>
    );
  }
}

Alerts.propTypes = PropTypes.arrayOf(PropTypes.shape(ALERT)).isRequired;

function mapStateToProps({ helpcenterAlerts }) {
  return { alerts: helpcenterAlerts.alerts };
}

export default connect(mapStateToProps)(Alerts);



// WEBPACK FOOTER //
// ./contactUs/containers/Alerts.js